/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

export const updateCreatedCollections = createAction('import/updateCreatedCollections');

export const reducer = (builder) => {
  builder.addCase(
    updateCreatedCollections.type,
    (state, { payload: createdCollections }) => {
      state.createdCollections = createdCollections;
    },
  );
};
